import { connect } from 'react-redux';
import BranchWrapper from "../components/general/BranchWrapper";
import { REMOVE_BRANCH } from "../store/actions/branch";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        REMOVE_BRANCH: body => dispatch(REMOVE_BRANCH(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BranchWrapper);


// WEBPACK FOOTER //
// ./src/containers/Branch.js